export const selectAssistantType = state => state.assistants.type;
export const selectAssistant = state => state.assistants;